<template>
    <div>
        <el-form
            ref="form"
            :inline="true"
            :model="query"
            class="query-form filter-block"
            size="mini"
        >
            <el-form-item label="流量词:" class="query-form-item">
                <el-input
                    v-model="query.keyword"
                    placeholder="请输入流量词"
                    clearable
                ></el-input>
            </el-form-item>
            <el-form-item>
                <!--<el-button icon="el-icon-refresh" @click="onReset"></el-button>-->
                <el-button
                    icon="el-icon-search"
                    type="primary"
                    @click="onSubmit"
                >查询
                </el-button>
                <el-button
                    icon="el-icon-refresh"
                    type="primary"
                    :loading="refreshLoading"
                    @click="refreshFlowWord"
                >刷新广告组合流量词
                </el-button>
                <el-button
                    type="success"
                    @click="import_file"
                >导入流量词
                </el-button
                >
                <el-button
                    type="success"
                    @click="export_file"
                >导出流量词
                </el-button
                >
                <el-button
                    style="margin: 5px 0 5px 10px"
                    type="danger"
                    size="mini"
                    @click.native="onDelete()"
                >批量删除
                </el-button
                >
                <el-button
                    style="margin: 5px 0 5px 10px"
                    type="danger"
                    size="mini"
                    @click.native="onDeleteAll()"
                >全部删除
                </el-button
                >

                <!--                <el-checkbox style="margin: 5px 0 5px 10px" v-model="showOne" @change="renderChart()">显示无效词数据-->
                <!--                </el-checkbox>-->
                <!--                <el-checkbox style="margin: 5px 0 5px 10px" v-model="showTwo" @change="renderChart()">显示否定词根数据-->
                <!--                </el-checkbox>-->

                <el-tooltip class="item" effect="dark" placement="top">
                    <div slot="content">
                        展示量、搜索量、关键词排名、自然排名、SP排名的数据是由Excel进行导入显示，<br/>
                        只展示爬取时间近90天的排名数据，<br/>
                        当数据值为”--”表示近90天导入的Excel没有该关键词的数据，当值为空时，表示属于排名外的数据。
                    </div>
                    <el-button type="danger" style="margin-left: 10px">注意</el-button>
                </el-tooltip>
            </el-form-item>
        </el-form>
        <el-table
            v-loading="loading"
            :data="previewDataList"
            size="mini"
            ref="multipleTable"
            @selection-change="handleSelectionChange"
            @sort-change="handleSortChange"
            :row-class-name="tableRowClassName"
            border
            style="width: 100%;"
        >
            <el-table-column type="selection" width="40" align="center">
            </el-table-column>
            <el-table-column
                label="id"
                width="150"
                align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.id }}</div>
                </template>
            </el-table-column>
            <el-table-column
                label="流量词"
                prop="flow_of_words"
                width="200"
                align="center"
            >
                <template slot-scope="scope">
                    <div>{{ scope.row.flow_of_words }}</div>
                </template>
            </el-table-column>
            <el-table-column label="属性" width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.attribute }}</div>
                </template>
            </el-table-column>
            <el-table-column
                label="词根"
                width="150"
                align="center"
            >
                <template slot-scope="scope">
                    <div>{{ scope.row.keyword_core_etyma }}</div>
                </template>
            </el-table-column>

            <!--            <el-table-column label="关键词排名" min-width="120" align="center">-->
            <!--                <template slot-scope="scope">-->
            <!--                    <div>{{ scope.row.keyword_rank }}</div>-->
            <!--                </template>-->
            <!--            </el-table-column>-->
            <!--            <el-table-column label="展示量" min-width="120" align="center">-->
            <!--                <template slot-scope="scope">-->
            <!--                    <div>{{ scope.row.display_amount }}</div>-->
            <!--                </template>-->
            <!--            </el-table-column>-->
            <!--            <el-table-column label="周搜索量" min-width="120" align="center">-->
            <!--                <template slot-scope="scope">-->
            <!--                    <div>{{ scope.row.search_volume }}</div>-->
            <!--                </template>-->
            <!--            </el-table-column>-->
            <!--            <el-table-column label="自然排名" min-width="120" align="center">-->
            <!--                <template slot-scope="scope">-->
            <!--                    <div>{{ scope.row.nature_rank }}</div>-->
            <!--                    <div>{{ scope.row.nature_rank_page }}</div>-->
            <!--                    <div>{{ scope.row.origin_nature_rank_curl_time }}</div>-->
            <!--                </template>-->
            <!--            </el-table-column>-->
            <!--            <el-table-column label="sp排名" min-width="120" align="center">-->
            <!--                <template slot-scope="scope">-->
            <!--                    <div>{{ scope.row.sp_rank }}</div>-->
            <!--                    <div>{{ scope.row.sp_rank_page }}</div>-->
            <!--                    <div>{{ scope.row.origin_nature_rank_curl_time }}</div>-->
            <!--                </template>-->
            <!--            </el-table-column>-->

            <el-table-column label="品牌" width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.brand }}</div>
                </template>
            </el-table-column>
            <!--            <el-table-column label="是否出过单" width="110" align="center">-->
            <!--                <template slot-scope="scope">-->
            <!--                    <span>{{ scope.row.has_order }}</span>-->
            <!--                    &lt;!&ndash; <el-tag v-if="scope.row.tag == 1" type="success">是</el-tag>-->
            <!--                    <el-tag v-else type="info">否</el-tag> &ndash;&gt;-->
            <!--                </template>-->
            <!--            </el-table-column>-->
            <!--            <el-table-column label="广告Campaign Name" min-width="150" align="center">-->
            <!--                <template slot-scope="scope">-->
            <!--                    <div>{{ scope.row.campaign_name }}</div>-->
            <!--                </template>-->
            <!--            </el-table-column>-->
            <el-table-column label="广告匹配方式" width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.match_type }}</div>
                </template>
            </el-table-column>
            <!--            <el-table-column label="日搜索量" min-width="120" align="center">-->
            <!--                <template slot-scope="scope">-->
            <!--                    <div>{{ scope.row.search_volume }}</div>-->
            <!--                </template>-->
            <!--            </el-table-column>-->
            <!--            <el-table-column-->
            <!--                :resizable="false"-->
            <!--                align="center"-->
            <!--                min-width="120"-->
            <!--                label="日搜索趋势"-->
            <!--            >-->
            <!--                <template slot-scope="scope">-->
            <!--                    <div-->
            <!--                        v-loading="loadingkeyword_tracker"-->
            <!--                        :id="'keyword_tracker' + scope.row.flow_of_words"-->
            <!--                        @click="oncharts_keyword(scope.row)"-->
            <!--                        class="chart spinner_div"-->
            <!--                    ></div>-->
            <!--                </template>-->
            <!--            </el-table-column>-->

            <!--            <el-table-column label="ara排名" min-width="120" align="center">-->
            <!--                <template slot-scope="scope">-->
            <!--                    <div @click="oncharts_arakeyword(scope.row)">-->
            <!--                        {{ scope.row.ara_data_rank }}-->
            <!--                    </div>-->
            <!--                </template>-->
            <!--            </el-table-column>-->
            <!--            <el-table-column-->
            <!--                :resizable="false"-->
            <!--                align="center"-->
            <!--                min-width="120"-->
            <!--                label="ara排名趋势"-->
            <!--            >-->
            <!--                <template slot-scope="scope">-->
            <!--                    <div-->
            <!--                        v-loading="loadingkeyword_aratracker"-->
            <!--                        :id="'keyword_aratracker' + scope.row.flow_of_words"-->
            <!--                        @click="oncharts_arakeyword(scope.row)"-->
            <!--                        class="chart spinner_div"-->
            <!--                    ></div>-->
            <!--                </template>-->
            <!--            </el-table-column>-->
            <!--            <el-table-column-->
            <!--                :resizable="false"-->
            <!--                label="自然排名"-->
            <!--                min-width="80"-->
            <!--                align="center"-->
            <!--            >-->
            <!--                <template slot-scope="scope">-->
            <!--                    <div-->
            <!--                        @click="oncharts_zr(scope.row)"-->
            <!--                        v-if="scope.row.rank_detail"-->
            <!--                    >-->
            <!--                        <div-->
            <!--                            v-if="scope.row.rank_detail.rank == null"-->
            <!--                            style="font-size: 12px;"-->
            <!--                        ></div>-->
            <!--                        <div-->
            <!--                            v-else-if="scope.row.rank_detail.rank == -1"-->
            <!--                            style="font-size: 12px;"-->
            <!--                        >-->
            <!--                            > 306-->
            <!--                        </div>-->
            <!--                        <div v-else style="font-size: 12px;">-->
            <!--                            {{ scope.row.rank_detail.rank }}-->
            <!--                        </div>-->
            <!--                    </div>-->
            <!--                </template>-->
            <!--            </el-table-column>-->
            <!--            <el-table-column-->
            <!--                :resizable="false"-->
            <!--                align="center"-->
            <!--                min-width="120"-->
            <!--                label="自然排名趋势"-->
            <!--            >-->
            <!--                <template slot-scope="scope">-->
            <!--                    <div-->
            <!--                        v-loading="loadingkeyword_zrtracker"-->
            <!--                        :id="'keyword_zrtracker' + scope.row.flow_of_words"-->
            <!--                        @click="oncharts_zr(scope.row)"-->
            <!--                        class="chart spinner_div"-->
            <!--                    ></div>-->
            <!--                </template>-->
            <!--            </el-table-column>-->
            <!--            <el-table-column label="广告排名" min-width="150" align="center">-->
            <!--                <template slot-scope="scope">-->
            <!--                    <div-->
            <!--                        @click="oncharts_ad(scope.row)"-->
            <!--                        v-if="scope.row.rank_detail"-->
            <!--                    >-->
            <!--                        <div-->
            <!--                            v-for="(item, i) in scope.row.rank_detail.ad_rank"-->
            <!--                            :key="i"-->
            <!--                        >-->
            <!--                            {{ item }}-->
            <!--                        </div>-->
            <!--                    </div>-->
            <!--                </template>-->
            <!--            </el-table-column>-->
            <!--            <el-table-column-->
            <!--                :resizable="false"-->
            <!--                align="center"-->
            <!--                min-width="120"-->
            <!--                label="广告排名趋势"-->
            <!--            >-->
            <!--                <template slot-scope="scope">-->
            <!--                    <div-->
            <!--                        v-loading="loadingkeyword_adtracker"-->
            <!--                        :id="'keyword_adtracker' + scope.row.flow_of_words"-->
            <!--                        @click="oncharts_ad(scope.row)"-->
            <!--                        class="chart spinner_div"-->
            <!--                    ></div>-->
            <!--                </template>-->
            <!--            </el-table-column>-->

            <el-table-column label="是否广告" width="100" align="center">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.is_in_advertised_word == 1" type="success">是</el-tag>
                    <el-tag v-else type="info">否</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="是否在否定词根里" width="120" align="center">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.is_in_negative_etyma == 1" type="success">是</el-tag>
                    <el-tag v-else type="info">否</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="是否在无效词里" width="120" align="center">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.is_in_invalid == 1" type="success">是</el-tag>
                    <el-tag v-else type="info">否</el-tag>
                </template>
            </el-table-column>

            <!--            <el-table-column label="操作" width="120" align="center">-->
            <!--                <template slot-scope="scope">-->
            <!--                    <div @click.stop>-->
            <!--                        <el-button-->
            <!--                            style="margin: 5px 0 5px 10px"-->
            <!--                            type="success"-->
            <!--                            size="mini"-->
            <!--                            :disabled="disabled"-->
            <!--                            @click.native="Add_crawl(scope.row)"-->
            <!--                        >加入爬取列表-->
            <!--                        </el-button-->
            <!--                        >-->
            <!--                        &lt;!&ndash; <el-button v-if="scope.row.is_ad == 1" style="margin: 5px 0 5px 10px" type="primary" size="mini" :disabled="disabled">降bid提醒</el-button> &ndash;&gt;-->
            <!--                    </div>-->
            <!--                </template>-->
            <!--            </el-table-column>-->
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="query.limit"
            :page-sizes="[20, 50, 100]"
            :total="query.total"
            background
            style="float: left;margin-top: 10px; margin-bottom: 5px"
            layout="total, sizes, prev, pager, next"
        >
        </el-pagination>
        <charts-keyword
            ref="charts_keyword_"
            :visible="ctrl.charts_keywordVisible"
            :title="ctrl.dialogTitle"
            :charts_keyword="charts_keyword"
            :charts_id="charts_keyword"
            @close-callback="closeCllback"
        ></charts-keyword>
        <charts
            ref="charts"
            :visible="ctrl.chartsVisible"
            :title="ctrl.dialogTitle"
            :charts_keyword="charts_keyword"
            :charts_id="charts_keyword"
            @close-callback="closeCllback"
        ></charts>
        <charts-ad
            ref="charts_ad"
            :visible="ctrl.charts_adVisible"
            :title="ctrl.dialogTitle"
            :charts_keyword="charts_keyword"
            :charts_state="charts_state"
            @close-callback="closeCllback"
        ></charts-ad>
        <charts-zr
            ref="charts_zr"
            :visible="ctrl.charts_zrVisible"
            :title="ctrl.dialogTitle"
            :charts_keyword="charts_keyword"
            :charts_state="charts_state"
            @close-callback="closeCllback"
        ></charts-zr>
        <download-list :visible="this.downloadListVisible" @close-callback="closeCllback"
                       :id="datasrow.id"></download-list>
        <import-data ref="importDataModal" @close-callback="closeCllbackImport"></import-data>
        <downloadExcelDialog ref="downloadExcelDialogRef" title="下载列表"/>
    </div>
</template>

<script>
    import * as api from '@/api/etyma/etyma'
    import * as apis from '@/api/Product/Product'
    import {binary_download} from '@/utils/method'
    import * as Highcharts from 'highcharts'
    import {downLoadFilePy} from '../../utils/method'
    import ChartsKeyword from './components/charts_keyword'
    import Charts from './charts'
    import ChartsAd from './charts_ad'
    import ChartsZr from './charts_zr'
    import DownloadList from './downloadList'
    import importData from './importData'
    import downloadExcelDialog from '@/views/etymaPhp/components/downloadExcelDialog.vue'
    import detailTableDialog from '@/views/operationManagement/depend/detailTableDialog.vue'
    export default {
        props: {
            datasrow: {
                type: Object,
                default: () => {
                }
            }
        },
        components: {
            detailTableDialog,
            DownloadList, ChartsKeyword, Charts, ChartsAd, ChartsZr, importData, downloadExcelDialog},
        computed: {
            previewDataList() {
                // return this.list.filter(item => ((item.is_invalid == 1 && this.showOne) || item.is_invalid == 0) && ((item.is_disavowal == 1 && this.showTwo) || item.is_disavowal == 0))
                return this.list
            }
        },
        data() {
            return {
                downloadListVisible: false,
                refreshLoading: false,
                showOne: false,
                showTwo: false,
                ctrl: {
                    charts_keywordVisible: false,
                    charts_zrVisible: false,
                    charts_adVisible: false,
                    chartsVisible: false
                },
                query: {
                    page: 1,
                    limit: 20,
                    list_id: null,

                },
                charts_keyword: '',
                charts_state: '',
                auto_str_brand: '自动适配品牌',
                auto_str_group: '自动适配词根',
                list: [],
                multipleSelection: [],
                disabled: false,
                disabledbrand: false,
                disabledgroup: false,
                autotype_brand: 'success',
                autotype_group: 'success',
                loadingkeyword_tracker: false,
                loadingkeyword_aratracker: false,
                loadingkeyword_zrtracker: false,
                loadingkeyword_adtracker: false,
                loading: false,
                loadingdownload: false,
                downloadmsg: '导出数据',
                requestCount: 0,
                state: ''
            }
        },
        mounted() {
            this.query.asin = this.datasrow.parent_asin
            this.state = this.datasrow.state
            this.$bus.$once('auto_fit_state', () => {
                if (this.datasrow.brand_tag === 1) {
                    this.auto_fit_state(
                        this.datasrow.brand_progress_key,
                        'disabledbrand',
                        'auto_str_brand',
                        'autotype_brand',
                        '自动适配品牌'
                    )
                }
                if (this.datasrow.ad_group_tag === 1) {
                    this.auto_fit_state(
                        this.datasrow.ad_group_progress_key,
                        'disabledgroup',
                        'auto_str_group',
                        'autotype_group',
                        '自动适配词根'
                    )
                }
                if (this.datasrow.seed_word_export_tag === 1) {
                    this.auto_fit_state(
                        this.datasrow.seed_word_export_progress_key,
                        'loadingdownload',
                        'downloadmsg',
                        '',
                        '导出数据'
                    )
                }
            })
            this.getList()
        },
        methods: {
            closeCllbackImport(isshow) {
                this.$refs.importDataModal.visible = false
                isshow == true && this.getList()
            },
            import_file() {
                this.$refs.importDataModal.functionStr = 'seed_word_traffic_word_import'
                this.$refs.importDataModal.fileTxt = '上传流量词数据模板.xlsx'
                this.$refs.importDataModal.tipTxt = '上传流量词数据模板'
                this.$refs.importDataModal.title = '导入流量词数据'
                this.$refs.importDataModal.asin = this.query.asin
                this.$refs.importDataModal.list_id = this.query.list_id

                this.$refs.importDataModal.visible = true
            },
            export_file(){
                this.$refs.downloadExcelDialogRef.showModal(this.datasrow.id)
            },
            getList() {
                // if (asin) {
                //     if (this.query.asin != null) return;
                //     this.query.asin = asin;
                //     this.state = state;
                // }
                this.query.list_id = this.datasrow.id
                let count = this.requestCount
                count = count + 1
                this.requestCount = count
                this.loading = true
                this.loadingkeyword_tracker = true
                this.loadingkeyword_aratracker = true
                this.loadingkeyword_zrtracker = true
                this.loadingkeyword_adtracker = true
                apis.seed_word_traffic_word_lists(this.query)
                    .then(res => {
                        this.loading = false
                        if (this.requestCount != count) {
                            this.loadingWorkload = false
                            this.loadingkeyword_tracker = false
                            this.loadingkeyword_aratracker = false
                            this.loadingkeyword_zrtracker = false
                            this.loadingkeyword_adtracker = false
                            return
                        }
                        if (res.code === 0) {
                            this.list = res.data.list
                            this.query.total = res.data.total
                            let that = this
                            let list = JSON.parse(JSON.stringify(that.list))
                            this.handleDetaiList(list)
                            // this.renderChart()
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.message
                            })
                        }
                    })
                    .catch(() => {
                        this.loading = false
                    })
            },
            handleDetaiList(list) {
                // let arr = list.map(item=>item.flow_of_words)
                // arr = Array.from(new Set(arr))
                // seed_word_asin_keyword_get_detail_list({id: this.datasrow.id, keywords: arr}).then((res) => {
                //     if (res.success) {
                //         for(const index in this.list) {
                //             const keyWord = this.list[index].flow_of_words
                //            if( res.data[keyWord]) {
                //                this.$set(this.list, index, Object.assign(this.list[index], res.data[keyWord]))
                //            }
                //         }
                //     }
                // })
            },
            renderChart() {
                if (this.previewDataList.length < 1) {
                    return
                }
                const count = this.requestCount
                const state = this.state
                let arr = []
                for (const item of this.previewDataList) {
                    arr.push(item.flow_of_words)
                }

                if (arr.length != 0) {
                    this.trend_batch(
                        arr,
                        state,
                        count
                    )
                    this.aratrend_batch(
                        arr,
                        state,
                        count
                    )
                    // this.onLower(
                    //     arr,
                    //     state,
                    //     count
                    // )
                    // this.onseed_word(
                    //     arr,
                    //     state,
                    //     count
                    // )
                    // this.zrtrend_batch(
                    //     arr,
                    //     state,
                    //     count
                    // )
                    // this.adtrend_batch(
                    //     arr,
                    //     state,
                    //     count
                    // )
                } else {
                    this.loadingkeyword_tracker = false
                    this.loadingkeyword_aratracker = false
                    this.loadingkeyword_zrtracker = false
                    this.loadingkeyword_adtracker = false
                }
            },
            handleSortChange(val) {
                this.query.field = val.prop
                if (val.order == 'ascending') {
                    this.query.desc = 0
                } else if (val.order == 'descending') {
                    this.query.desc = 1
                } else {
                    this.query.desc = null
                }
                this.getList()
            },
            tableRowClassName({row}) {
                if (row.tag == 1) {
                    return 'warningred'
                }
                return ''
            },
            //获取降bid提醒
            async onseed_word(arr, country_code, count) {
                let that = this
                if (that.requestCount != count) {
                    return
                }
                await api
                    .get_seed_word_rank_detail({
                        keyword_list: arr,
                        state: country_code,
                        asin: this.query.asin
                    })
                    .then(res => {
                        if (that.requestCount != count) return
                        let list = JSON.parse(JSON.stringify(that.list))
                        if (res.code === 0) {
                            let data = res.data
                            for (let i = 0; i < list.length; i++) {
                                list[i].rank_detail =
                                    data[list[i].flow_of_words].rank_detail
                            }
                            that.list = list
                        } else {
                            that.$message({
                                type: 'error',
                                message: res.message
                            })
                        }
                    })
                    .catch(() => {
                        that.loadingkeyword_tracker = false
                    })
            },
            //打开曲线图广告
            oncharts_ad(data) {
                this.charts_state = this.state
                this.charts_keyword = data.flow_of_words
                this.formData = this.data
                this.ctrl.dialogTitle = `${this.query.asin} : ${data.flow_of_words} (广告排名)`
                this.ctrl.charts_adVisible = true
                setTimeout(() => {
                    this.$refs.charts_ad.getList(this.state, 30, this.query.asin)
                }, 100)
            },
            oncharts_zr(data) {
                this.charts_state = this.state
                this.charts_keyword = data.flow_of_words
                this.formData = this.data
                this.ctrl.dialogTitle = `${this.query.asin} : ${data.flow_of_words} (自然排名)`
                this.ctrl.charts_zrVisible = true
                setTimeout(() => {
                    this.$refs.charts_zr.getList(this.state, 30, this.query.asin)
                }, 100)
            },
            //获取降bid提醒
            async onLower(arr, country_code, count) {
                let that = this
                if (that.requestCount != count) {
                    return
                }
                await api
                    .lower_bid_remind({
                        keyword_list: arr,
                        state: country_code,
                        asin: this.query.asin
                    })
                    .then(res => {
                        if (that.requestCount != count) return
                        let list = JSON.parse(JSON.stringify(that.list))
                        if (res.code === 0) {
                            let data = res.data
                            for (let i = 0; i < list.length; i++) {
                                list[i].tag = data[list[i].flow_of_words].tag
                            }
                            that.list = list
                        } else {
                            that.$message({
                                type: 'error',
                                message: res.message
                            })
                        }
                    })
                    .catch(() => {
                        that.loadingkeyword_tracker = false
                    })
            },
            //重置
            onReset() {
                this.quer.page = 1
                this.quer.limit = 20
                this.quer.like = ''
                this.getList()
            },
            //查询
            onSubmit() {
                this.query.page = 1
                this.getList()
            },
            refreshFlowWord() {
                this.refreshLoading = true
                apis.seed_word_task_update_traffic_word({id: this.query.list_id}).then(res => {
                    if (res.code === 0) {
                        this.$alert(res.data || '', '提示', {
                            confirmButtonText: '关闭',
                            callback: () => this.getList()
                        });
                    } else {
                        this.$message({type: 'error', message: res.message})
                    }
                }).catch(() => {
                    that.loadingkeyword_tracker = false
                }).finally(()=>{
                    this.refreshLoading = false
                })
            },
            //获取关键词曲线图数据
            async trend_batch(arr, country_code, count) {
                let that = this
                if (that.requestCount != count) {
                    return (that.loadingkeyword_tracker = false)
                }
                await apis
                    .search_trend_batch({
                        keywords: arr,
                        days: null,
                        country_code: country_code
                    })
                    .then(res => {
                        that.loadingkeyword_tracker = false
                        if (that.requestCount != count) return
                        let list = JSON.parse(JSON.stringify(that.list))
                        if (res.code === 0) {
                            let data = res.data
                            for (let i = 0; i < list.length; i++) {
                                list[i].show_num_sum_date =
                                    data[list[i].flow_of_words].date
                                list[i].show_num_sum =
                                    data[list[i].flow_of_words].show_num_sum
                            }
                            that.list = list
                            for (let i = 0; i < that.list.length; i++) {
                                if (that.list[i].show_num_sum) {
                                    that.workload_tracker('keyword_tracker' + that.list[i].flow_of_words, that.list[i])
                                }
                            }
                        } else {
                            that.$message({
                                type: 'error',
                                message: res.message
                            })
                        }
                    })
                    .catch(() => {
                        that.loadingkeyword_tracker = false
                    })
            },
            //获取关键词曲线图数据
            async aratrend_batch(arr, country_code, count) {
                let that = this
                if (that.requestCount != count) {
                    return (that.loadingkeyword_aratracker = false)
                }
                await apis.ara_index_trend_batch({
                    search_word_list: arr,
                    amazon_site: country_code == 'US' ? 'Amazon.com' : (country_code == 'DE' ? 'Amazon.de' : 'Amazon.co.uk')
                })
                    .then(res => {
                        that.loadingkeyword_aratracker = false
                        if (that.requestCount != count) return
                        let list = JSON.parse(JSON.stringify(that.list))
                        if (res.code === 0) {
                            let data = res.data
                            for (let i = 0; i < list.length; i++) {
                                list[i].ara_date = []
                                for (
                                    let j = 0;
                                    j < data[list[i].flow_of_words].year.length;
                                    j++
                                ) {
                                    let str = data[list[i].flow_of_words].year[j] + '-' + data[list[i].flow_of_words].month[j]
                                    list[i].ara_date.push(str)
                                }
                                list[i].search_rank_list = data[list[i].flow_of_words].search_rank
                                // list[i].search_rank_list = [1,0,0,1];
                            }
                            that.list = list
                            for (let i = 0; i < that.list.length; i++) {
                                if (that.list[i].search_rank_list) {
                                    that.workload_aratracker('keyword_aratracker' + that.list[i].flow_of_words, that.list[i])
                                }
                            }
                        } else {
                            that.$message({
                                type: 'error',
                                message: res.message
                            })
                        }
                    })
                    .catch(() => {
                        that.loadingkeyword_aratracker = false
                    })
            },
            async zrtrend_batch(arr, country_code, count) {
                let that = this
                if (that.requestCount != count) {
                    return (that.loadingkeyword_zrtracker = false)
                }
                await api
                    .keyword_rank_batch({
                        keyword_list: arr,
                        state: country_code,
                        last_day: 0,
                        rank_type: 1,
                        asin: this.query.asin
                    })
                    .then(res => {
                        that.loadingkeyword_zrtracker = false
                        if (that.requestCount != count) return
                        let list = JSON.parse(JSON.stringify(that.list))
                        if (res.code === 0) {
                            let data = res.data
                            for (let i = 0; i < list.length; i++) {
                                list[i].zr_date = data[list[i].flow_of_words].date
                                list[i].zr_rank = data[list[i].flow_of_words].rank
                            }
                            that.list = list
                            for (let i = 0; i < that.list.length; i++) {
                                if (that.list[i].zr_rank) {
                                    that.workload_zr_adtracker('keyword_zrtracker' + that.list[i].flow_of_words, that.list[i])
                                }
                            }
                        } else {
                            that.$message({
                                type: 'error',
                                message: res.message
                            })
                        }
                    })
                    .catch(() => {
                        that.loadingkeyword_zrtracker = false
                    })
            },
            async adtrend_batch(arr, country_code, count) {
                let that = this
                if (that.requestCount != count) {
                    return (that.loadingkeyword_adtracker = false)
                }
                await api
                    .keyword_rank_batch({
                        keyword_list: arr,
                        state: country_code,
                        last_day: 0,
                        rank_type: 2,
                        asin: this.query.asin
                    })
                    .then(res => {
                        that.loadingkeyword_adtracker = false
                        if (that.requestCount != count) return
                        let list = JSON.parse(JSON.stringify(that.list))
                        if (res.code === 0) {
                            let data = res.data
                            for (let i = 0; i < list.length; i++) {
                                list[i].zr_date = data[list[i].flow_of_words].date
                                list[i].zr_rank = data[list[i].flow_of_words].rank
                            }
                            that.list = list
                            for (let i = 0; i < that.list.length; i++) {
                                if (that.list[i].zr_rank) {
                                    that.workload_zr_adtracker(
                                        'keyword_adtracker' +
                                        that.list[i].flow_of_words,
                                        that.list[i]
                                    )
                                }
                            }
                        } else {
                            that.$message({
                                type: 'error',
                                message: res.message
                            })
                        }
                    })
                    .catch(() => {
                        that.loadingkeyword_adtracker = false
                    })
            },
            workload_tracker(id_name, data) {
                let workload_id = document.getElementById(id_name)
                let datas = []
                for (let i = 0; i < data.show_num_sum.length; i++) {
                    datas.push(
                        data.show_num_sum[i] == null ? null : data.show_num_sum[i] * -1
                    )
                }
                this.sparkLine(workload_id, datas, data.show_num_sum_date, 2)
            },
            workload_aratracker(id_name, data) {
                let workload_id = document.getElementById(id_name)
                let datas = []
                for (let i = 0; i < data.search_rank_list.length; i++) {
                    datas.push(
                        data.search_rank_list[i] == null ||
                        data.search_rank_list[i] == 0 ? null : data.search_rank_list[i]
                    )
                }
                this.sparkLine(workload_id, datas, data.ara_date, 1)
            },
            workload_zr_adtracker(id_name, data) {
                let workload_id = document.getElementById(id_name)
                let datas = []
                for (let i = 0; i < data.zr_rank.length; i++) {
                    datas.push(data.zr_rank[i] == null || data.zr_rank[i] == 0 || data.zr_rank[i] == -1 ? null : data.zr_rank[i])
                }
                this.sparkLine(workload_id, datas, data.zr_date, 1)
            },
            sparkLine(div, datas, dates, index) {
                var options = {
                    chart: {
                        borderWidth: 0,
                        backgroundColor: '#fff',
                        // type: "area",
                        margin: [8, 40, 8, 10],
                        width: 100,
                        height: 36,
                        style: {
                            overflow: 'visible'
                        },
                        skipClone: true
                    },
                    title: {
                        text: null
                    },
                    credits: {
                        enabled: false
                    },
                    xAxis: {
                        categories: dates,
                        labels: {
                            enabled: false
                        },
                        title: {
                            text: null
                        },
                        startOnTick: false,
                        endOnTick: false,
                        tickPositions: [],
                        tickWidth: 0,
                        lineColor: '#fff'
                    },
                    yAxis: {
                        reversed: true,
                        labels: {
                            enabled: false
                        },
                        title: {
                            text: null
                        },
                        minPadding: 0,
                        startOnTick: false,
                        endOnTick: false,
                        tickPositions: []
                    },
                    legend: {
                        enabled: false
                    },
                    exporting: {enabled: false},
                    tooltip: {
                        formatter: function () {
                            if (index == 1) {
                                return `<span style="font-size: 10px;">${this.x}</span><br/><b>${this.y}</b>`
                            }
                            if (index == 2) {
                                return `<span style="font-size: 10px;">${
                                    this.x
                                }</span><br/><b>${this.y * -1}</b>`
                            }
                        },
                        hideDelay: 0,
                        outside: true
                    },
                    series: [{data: datas}],
                    plotOptions: {
                        series: {
                            animation: false,
                            lineWidth: 1,
                            shadow: false,
                            states: {
                                hover: {
                                    lineWidth: 1
                                }
                            },
                            marker: {
                                radius: 1,
                                states: {
                                    hover: {
                                        radius: 2
                                    }
                                }
                            },
                            fillOpacity: 0.25
                        },
                        column: {
                            negativeColor: '#910000',
                            borderColor: 'silver'
                        }
                    }
                }
                return new Highcharts.Chart(div, options)
            },
            //打开关键词曲线图
            oncharts_keyword(data) {
                let that = this
                this.charts_keyword = data.flow_of_words
                this.ctrl.dialogTitle = `${data.flow_of_words} 的搜索趋势图`
                this.ctrl.charts_keywordVisible = true
                setTimeout(function () {
                    that.$refs.charts_keyword_.getList(
                        data.flow_of_words,
                        null,
                        that.state
                    )
                }, 100)
            },
            //打开关键词曲线图ara
            oncharts_arakeyword(data) {
                let that = this
                this.charts_keyword = data.flow_of_words
                this.ctrl.dialogTitle = `${data.flow_of_words} 的ara排名趋势图`
                this.ctrl.chartsVisible = true
                setTimeout(function () {
                    that.$refs.charts.getList(data.flow_of_words, that.state)
                }, 100)
            },
            //加入爬取列表
            Add_crawl(data) {
                this.disabled = true
                api.add_keyword_to_spider({
                    keyword_list: [
                        {
                            keyword: data.flow_of_words,
                            asin: data.asin,
                            state: this.state
                        }
                    ]
                })
                    .then(res => {
                        this.disabled = false
                        if (res.code === 0) {
                            this.$message({
                                message: '加入成功',
                                type: 'success'
                            })
                            // this.getList();
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.message
                            })
                        }
                    })
                    .catch(() => {
                        this.disabled = false
                    })
            },
            onDelete() {
                if (this.multipleSelection.length == 0) {
                    return this.$message({
                        type: 'error',
                        message: '请勾选需要删除的种子词库！'
                    })
                }
                this.$confirm(
                    `确定要删除 ${this.query.asin} 下的 ${this.multipleSelection.length} 个种子词库吗？`,
                    {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }
                )
                    .then(() => {
                        this.loading = true
                        apis.seed_word_traffic_word_delete({
                            ids: this.multipleSelection,
                            all_deleted: 0,
                            list_id: this.query.list_id,
                        })
                            .then(res => {
                                this.loading = false
                                if (res.code === 0) {
                                    this.$message({
                                        message: '删除成功',
                                        type: 'success'
                                    })
                                    this.getList()
                                } else {
                                    this.$message({
                                        type: 'error',
                                        message: res.message
                                    })
                                }
                            })
                            .catch(() => {
                                this.loading = false
                            })
                    })
                    .catch(() => {
                    })
            },
            onDeleteAll() {
                this.$confirm(`确定要删除全部种子词库吗？`, {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        this.loading = true
                        apis.seed_word_traffic_word_delete({
                            ids: this.multipleSelection,
                            all_deleted: 1,
                            list_id: this.query.list_id,
                        })
                            .then(res => {
                                this.loading = false
                                if (res.code === 0) {
                                    this.$message({
                                        message: '全部删除成功',
                                        type: 'success'
                                    })
                                    this.getList()
                                } else {
                                    this.$message({
                                        type: 'error',
                                        message: res.message
                                    })
                                }
                            })
                            .catch(() => {
                                this.loading = false
                            })
                    })
                    .catch(() => {
                    })
            },
            generateNewData(force = 0) {
                apis.seed_word_traffic_word_create_excel_file({
                    list_id: this.datasrow.id,
                }).then(res => {
                    if (res.success) {
                        this.$message({
                            message: res.data,
                            type: 'success'
                        })
                    } else {
                        this.$message({
                            message: res.message,
                            type: 'error'
                        })
                    }
                })
            },
            downloadList() {
                this.downloadListVisible = true
            },
            //多选框
            handleSelectionChange(val) {
                let arr = []
                val.map(v => {
                    arr.push(v.id)
                })
                this.multipleSelection = arr
            },
            download_file_process() {
                let obj = {
                    asin: this.query.asin,
                    state: this.datasrow.state,
                    ad_portfolio_name_id: this.datasrow.ad_portfolio_name_id
                }
                this.loadingdownload = true
                this.downloadmsg = '正在导出数据'
                api.seed_keyword_file_export(obj).then(res => {
                    if (res.code === 1) {
                        this.$message.error(res.message)
                    } else {
                        this.auto_fit_state(
                            res.progress_key,
                            'loadingdownload',
                            'downloadmsg',
                            '',
                            '导出数据'
                        )
                    }

                })
            },
            //下载
            download_file() {
                // let obj = {
                //     asin: this.query.asin,
                //     state: this.datasrow.state,
                //     ad_portfolio_name_id: this.datasrow.ad_portfolio_name_id
                // };
                // this.loadingdownload = true;
                // this.downloadmsg = "正在导出数据";
                // api.asin_keyword_file_export(obj).then(res => {
                //     if (res.code === 1) {
                //         this.$message.error(res.message);
                //     } else {
                binary_download(
                    '/apis/v1/common_file_export_by_path',
                    'post',
                    {},
                    {
                        file_path: this.datasrow.seed_word_file_path
                    },
                    'application/vnd.ms-excel',
                    `种子词库数据.xlsx`
                )
                // }
                //     this.loadingdownload = false;
                //     this.downloadmsg = "导出数据";
                // });
            },
            //获取适配品牌进度
            auto_fit_state(str, disabled, auto_str, autotype, text) {
                api.get_progress_bar_detail({
                    progress_key: str
                })
                    .then(res => {
                        if (res.code === 0) {
                            if (res.data.tag == -1) {
                                this[disabled] = false
                                this[autotype] = 'danger'
                                this[
                                    auto_str
                                    ] = `${text}（更新失败：${res.message}）`
                            } else if (res.data.tag == 1) {
                                this[disabled] = false
                                this[autotype] = 'success'
                                this[auto_str] = `${text}（${res.data.message ||
                                '更新完成'}）`
                                this.$emit('getList')
                            } else {
                                this[autotype] = 'warning'
                                this[
                                    auto_str
                                    ] = `${text}（完成进度：${res.data.index} / ${res.data.total}）`
                                setTimeout(() => {
                                    this.auto_fit_state(
                                        str,
                                        disabled,
                                        auto_str,
                                        autotype,
                                        text
                                    )
                                }, 15000)
                            }
                        } else {
                            this[disabled] = false
                            this.$message({
                                type: 'error',
                                message: res.message
                            })
                        }
                    })
                    .catch(() => {
                        this.disabledbrand = false
                    })
            },
            //分页
            handleCurrentChange(val) {
                this.query.page = val
                this.getList()
            },
            handleSizeChange(val) {
                this.query.limit = val
                this.getList()
            },
            // 关闭弹窗回调
            closeCllback(isshow) {
                this.downloadListVisible = false
                this.ctrl.charts_keywordVisible = false
                this.ctrl.chartsVisible = false
                this.ctrl.charts_adVisible = false
                this.ctrl.charts_zrVisible = false
                if (isshow) return
                this.getList()
            },
            downFile() {
                downLoadFilePy(
                    this.datasrow.seed_word_file_path,
                    this.datasrow.last_match_time.substring(0, 10) +
                    this.datasrow.parent_asin +
                    '种子词数据'
                )
            }
        }
    }
</script>

<style type="text/scss" lang="scss" scoped>
    .filter-block {
        background-color: #a9c7ff;
        padding: 6px 6px 6px 10px;
        font-size: 18px;
        color: #333;
        margin: 0;
        display: flex;
        align-items: center;
    }

    /deep/ .warningred {
        background: rgb(243, 107, 107) !important;
    }

    /deep/ .el-form-item {
        margin-bottom: 0 !important;
    }
</style>
